/**
 * Valida CPF (algoritmo da Receita Federal).
 * Aceita formato com ou sem máscara.
 *
 * @param {string} cpf - CPF a validar (com ou sem máscara)
 * @returns {boolean} true se CPF é válido, false caso contrário
 *
 * @example
 * isValidCpf('111.444.777-35') // true
 * isValidCpf('11144477735') // true
 * isValidCpf('000.000.000-00') // false
 * isValidCpf('') // false
 */
export function isValidCpf(cpf) {
  if (!cpf) return false;

  // Remove non-digit characters
  const digits = cpf.replace(/\D/g, '');

  // Deve ter exatamente 11 dígitos
  if (digits.length !== 11) return false;

  // Rejeita CPFs com todos os dígitos iguais (e.g., 00000000000, 11111111111)
  if (/^(\d)\1{10}$/.test(digits)) return false;

  // Calcula um dígito verificador
  const calcDigit = (slice, factor) => {
    let sum = 0;
    for (let i = 0; i < slice.length; i++) {
      sum += parseInt(slice[i], 10) * (factor - i);
    }
    const rest = sum % 11;
    return rest < 2 ? 0 : 11 - rest;
  };

  // Valida primeiro dígito verificador
  const d1 = calcDigit(digits.slice(0, 9), 10);
  if (d1 !== parseInt(digits[9], 10)) return false;

  // Valida segundo dígito verificador
  const d2 = calcDigit(digits.slice(0, 10), 11);
  if (d2 !== parseInt(digits[10], 10)) return false;

  return true;
}
